import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    host: "https://wordpress.datacivica.org/wp-json/wp/v2",
    chapter1: {
      sectionId: "section1"
    },
    ch3SelectedState: "1",
    disease: "obesidad"
  },
  mutations: {},
  actions: {
    getBlog2({
      state
    }) {
      return axios.get(
        state.host +
        "/blog?slug=los-peores-estados-para-contraer-covid-19-en-mexico"
      );
    },
    getBlog3({
      state
    }) {
      return axios.get(
        state.host +
        "/blog?slug=el-privilegio-de-la-salud"
      );
    },
    getWomenCallsBlog({
      state
    }) {
      return axios.get(
        state.host +
        "/blog?slug=lo-que-nos-dicen-las-llamadas-de-auxilio-de-las-mujeres"
      )
    },
    getExcessDeathsBlog({
      state
    }) {
      return axios.get(
        state.host +
        "/blog?slug=dimensionando-la-tragedia-el-exceso-de-mortalidad-en-11-estados-del-pais"
      )
    },
    getVideos({
      state
    }) {
      return axios.get(
        state.host +
        "/viral_video"
      );
    }
  },
  modules: {}
});
